import { render, staticRenderFns } from "./FormulateCompanySitesManager.vue?vue&type=template&id=4b87ba68"
import script from "./FormulateCompanySitesManager.vue?vue&type=script&lang=js"
export * from "./FormulateCompanySitesManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports